import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';
import LeaveWarningModal from '../LeaveWarningModal';
import Wizard from '../Wizard';
import Loader from '../Loaders/Loader';
import useDeviceResize from '../../hooks/useDeviceResize';
import ProgressBar from '../Wizard/ProgressBar';
import { EFES_CONTENT_WIDTH, EFES_SUMMARY_WIDTH, FULL_WIDTH } from '../../constants/uiConstants';

import styles from './WizardWrapper.module.scss';

const WizardWrapper = (props) => {
  const {
    steps,
    stepParams,
    currentStep,
    setCurrentStep,
    unlockedSteps,
    setUnlockedSteps,
    goToStep,
    hasWarningModal,
    locationsWhitelist,
    summaryBlock,
    contractSummaryClassName,
  } = props;

  const { loader, showLoader } = stepParams;
  const { t } = useTranslation();
  const isDeviceMdSize = useDeviceResize('tabletLandscape');
  const isDeviceLgSize = useDeviceResize('lg');

  return (
    <div className={styles.wizardWrapper}>
      {showLoader && loader}
      {!isDeviceMdSize && (
        <ProgressBar
          steps={steps}
          currentStepNumber={currentStep.n}
          unlockedSteps={unlockedSteps}
          goToStep={goToStep}
        />
      )}
      <Grid container>
        <Grid
          item
          style={{
            width: isDeviceLgSize || !summaryBlock ? FULL_WIDTH : EFES_CONTENT_WIDTH,
            paddingRight: isDeviceLgSize || !summaryBlock ? 0 : 16,
          }}
        >
          <Box>
            <Wizard
              stepContainers={steps}
              stepParams={stepParams}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              unlockedSteps={unlockedSteps}
              setUnlockedSteps={setUnlockedSteps}
              goToStep={goToStep}
              isDeviceMdSize={isDeviceMdSize}
            />
          </Box>
        </Grid>
        <Grid
          item
          style={{
            width: isDeviceLgSize ? FULL_WIDTH : EFES_SUMMARY_WIDTH,
            paddingLeft: isDeviceLgSize || !summaryBlock ? 0 : 16,
          }}
        >
          {isDeviceLgSize ? (
            summaryBlock
          ) : (
            <Box className={contractSummaryClassName}>{summaryBlock}</Box>
          )}
        </Grid>
      </Grid>
      {hasWarningModal && (
        <LeaveWarningModal
          modalHeaderText={t('confirm')}
          modalText={t('confirmMessage')}
          locationsWhitelist={locationsWhitelist}
        />
      )}
    </div>
  );
};

WizardWrapper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      n: PropTypes.number.isRequired,
      id: PropTypes.string.isRequired,
      icon: PropTypes.shape({}),
      label: PropTypes.string,
    }),
  ).isRequired,
  stepParams: PropTypes.shape({
    type: PropTypes.string,
    loader: PropTypes.element,
    showLoader: PropTypes.bool,
  }),
  currentStep: PropTypes.shape({
    n: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    icon: PropTypes.shape({}),
    label: PropTypes.string,
  }),
  setCurrentStep: PropTypes.func,
  unlockedSteps: PropTypes.arrayOf(PropTypes.string),
  setUnlockedSteps: PropTypes.func,
  goToStep: PropTypes.func,
  hasWarningModal: PropTypes.bool,
  locationsWhitelist: PropTypes.arrayOf(PropTypes.string),
  summaryBlock: PropTypes.element,
  contractSummaryClassName: PropTypes.string,
};

WizardWrapper.defaultProps = {
  stepParams: {
    loader: <Loader />,
    showLoader: false,
  },
  currentStep: { id: '' },
  setCurrentStep: () => {},
  unlockedSteps: [],
  setUnlockedSteps: () => {},
  goToStep: () => {},
  hasWarningModal: false,
  locationsWhitelist: [],
  summaryBlock: null,
  contractSummaryClassName: '',
};

export default WizardWrapper;
